<template>
  <div>
    <vx-card  v-can="'view-supplier-raw-materials'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Supplier Name</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['company_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                     :options="['Pending','Approved', 'Rejected', 'Suspended - Level 1']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="RAW MATERIAL" v-can:any="['create-edit-supplier-raw-materials', 'view-supplier-raw-materials']">
          <template slot="actions">
            <vs-button class="mr-4" @click="onCLickCreateRawMaterial" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table  v-can="'view-supplier-raw-materials'" max-items="10" :data="staff"  @sort="handleSort"   stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%" sort-key="company_product_code">ITS PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="supplier_product_code">SUPPLIER PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="name">Manufacturing Sites</vs-th>
                <vs-th width="10%" sort-key="name">Alt RM</vs-th>
                <vs-th width="10%">APPROVAL STATUS</vs-th>
                <vs-th width="10%">PRODUCTION STAGE</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].company_product_code">
                    {{ data[indextr].company_product_code ? data[indextr].category.prefix+ ' - ' +data[indextr].company_product_code  : '-' }}
                    <br>
                    {{ data[indextr].company_product_name ?data[indextr].company_product_name : '-' }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_product_code">
                    {{ data[indextr].supplier_product_code }}
                    <br>
                    {{ data[indextr].supplier_product_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].manufacturing_site">
                    <span v-for="(site, index_of_sites) in data[indextr].manufacturing_site">
                      <span class="text-primary">{{site.site_name}}</span> ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].similar_raw_materials">
                    <span v-for="(site, index_of_similar_rm) in data[indextr].similar_raw_materials">
                      <span class="text-primary">{{site.supplier_product_name}}</span>,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent :color="statusColorFactory(data[indextr].status ? data[indextr].status.id : '')">
                      {{data[indextr].status ? data[indextr].status.name : ''}}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].raw_material_stage">
                    <vs-chip transparent :color="data[indextr].raw_material_stage === 'production' ? 'primary' : 'warning'">
                      {{data[indextr].raw_material_stage}}
                    </vs-chip>
                  </vs-td>


                  <vs-td v-can="'view-supplier-raw-materials'">
                    <div class="flex">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3"
                                   @click="onClickViewManufacturing(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-pop-up ref="createSupplierPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
    <create-raw-material-pop-up ref="createRawMaterialPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')

  import CreateSupplierPopUp from '@/components/popups/supplier/CreateSupplierPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import CreateRawMaterialPopUp from '@/components/popups/raw-materials/CreateRawMaterialPopUp'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        supplierId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp,
      CreateRawMaterialPopUp
    },
    mixins : [Filter],
    async mounted () {

      this.$refs.filterCard.isContentCollapsed = true
      this.$refs.filterCard.maxHeight = '1.5rem'

      this.$vs.loading()
      this.loadStaff()
      this.$vs.loading.close()

    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        this.supplierId = this.$route.params.id
        // const {data} = await SupplierManufactureRepository.getAllManufacturerSites(this.supplierId, this.page, this.filterQuery, 10, this.sort)
        const {data} = await SupplierRawMaterialRepository.getRawMaterialBySupplierId(this.supplierId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      onClickViewManufacturing(id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/${this.supplierId}/raw-material/${id}`})
      },
      async onClickCreateSupplier () {
        await this.$refs.createSupplierPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierView (id) {
        await this.$refs.viewSupplierPopUp.openPopup(id)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },
      async onCLickCreateRawMaterial() {
        await this.$refs.createRawMaterialPopUp.openPopup(this.supplierId)
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
